import ModaleAnimee from "./ModaleAnimee";
import React, { useState } from "react";
import toast from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
});

/* Les deux dashboards qui montent ce modal ont chacun leur copie de ces styles et de leur
   `Modal` ; on les redéclare ici plutôt que d'en importer un des deux, ce qui aurait couplé
   le Conseil Pédagogique au Commercial. */
const modalOverlay = { position:"fixed", top:0, left:0, width:"100%", height:"100%",
  background:"rgba(0,0,0,0.5)", display:"flex", justifyContent:"center", alignItems:"center", zIndex:9400 };
const modalBox = { background:"#fff", padding:24, borderRadius:14, width:560, maxWidth:"92vw",
  maxHeight:"90vh", overflowY:"auto" };
const btnPrimary = { padding:"9px 16px", background:"#1a4fd6", color:"#fff", border:"none",
  borderRadius:6, cursor:"pointer", fontWeight:600, fontSize:12 };
const btnSecondary = { padding:"9px 16px", background:"#e5e7eb", color:"#374151", border:"none",
  borderRadius:6, cursor:"pointer", fontWeight:600, fontSize:12 };

const Modal = ({ title, onClose, children }) => (
  <ModaleAnimee
    /* Le composant `Modal` local n'est rendu que lorsque son parent le monte :
       l'entrée s'anime, la sortie suit le démontage du parent. */
    ouvert
    onFermer={onClose}
    style={modalOverlay}
    panneauStyle={modalBox}
  >
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:18, gap:10 }}>
        <h3 style={{ margin:0, fontSize:16, flex:1 }}>{title}</h3>
        <button onClick={onClose} style={{ background:"none", border:"none", fontSize:20, cursor:"pointer", color:"#6b7280" }}>✕</button>
      </div>
      {children}
  </ModaleAnimee>
);

/**
 * ALIGNER LES MOIS À VENIR SUR LE TARIF COURANT.
 *
 * ──────────────────────────────────────────────────────────────────────────────────────────
 * CE QU'IL RÉPARE. Quand le prix d'un dossier change — au moment d'un changement de classe,
 * de canal ou de centre — `demandes-transfert` propose de l'appliquer « dès le mois en
 * cours ». Si la case n'est pas cochée, la nouvelle mensualité ne vaut que pour les mois à
 * CRÉER : ceux qui existent déjà gardent l'ancien prix, et un mois à venir encore impayé
 * continue d'être réclamé au tarif d'avant.
 *
 * Le bandeau le signalait, mais renvoyait à « refaites le changement de tarif » — c'est-à-dire
 * rouvrir une demande de transfert entière pour une seule case à cocher. Personne ne le fait.
 *
 * POURQUOI NOMMER LA CAUSE. Six semaines après, l'assistante qui ouvre le dossier ne sait plus
 * pourquoi octobre est à 5 F et la mensualité à 10 F. `changements_tarif` porte le motif du
 * geste qui a changé le prix ; on le lui redit en toutes lettres, sinon cette boîte lui demande
 * d'approuver une correction dont elle ignore l'origine.
 *
 * ON MONTRE CE QUI VA BOUGER, MOIS PAR MOIS, avant d'agir. Le serveur ne retouche ni un mois
 * passé, ni un mois déjà entamé par un versement, ni un mois gelé par une pause — autant que
 * la liste le dise d'avance plutôt que de laisser découvrir le résultat après coup.
 * ──────────────────────────────────────────────────────────────────────────────────────────
 */
const MOTIFS_TARIF = {
  changement_classe: "d'un changement de classe",
  migration_canal:   "d'une migration de canal (présentiel ↔ en ligne)",
  changement_centre: "d'un changement de centre",
};

const ModalAlignementTarif = ({ cible, onClose, onApplique }) => {
  const [envoi, setEnvoi] = useState(false);
  const { assignationId, prospectNom, mensualite, aRevoir = [], changement } = cible || {};
  const f = (n) => Number(n || 0).toLocaleString("fr-FR");

  const cause = MOTIFS_TARIF[changement?.motif] || null;
  const quand = changement?.le ? new Date(changement.le).toLocaleDateString("fr-FR") : null;

  const appliquer = async () => {
    if (envoi) return;
    setEnvoi(true);
    try {
      const r = await fetch(`${API_URL}/api/parcours/assignations/${assignationId}/aligner-tarif`, {
        method: "POST", headers: authHeaders(),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { toast.error(d.error || "Alignement impossible"); return; }
      toast.success(d.mois_realignes
        ? `✅ ${d.mois_realignes} mois réaligné${d.mois_realignes > 1 ? "s" : ""} sur ${f(mensualite)} F`
        : "Rien à aligner — les mois à venir étaient déjà au bon tarif");
      onApplique?.(d.plan_paiement);
    } catch { toast.error("Erreur réseau"); }
    finally { setEnvoi(false); }
  };

  return (
    <Modal title="Aligner les mois à venir sur le tarif actuel" onClose={onClose}>
      <div style={{ fontSize:13, lineHeight:1.6, color:"#374151" }}>
        {/* La cause d'abord : c'est elle qui rend la correction compréhensible. */}
        <div style={{ background:"#fef3c7", border:"1px solid #fcd34d", borderRadius:8, padding:"10px 12px", marginBottom:14 }}>
          <strong>Pourquoi cet écart ?</strong><br />
          Le tarif de {prospectNom || "ce dossier"} est passé à <strong>{f(mensualite)} F/mois</strong>
          {cause ? <> à la suite <strong>{cause}</strong></> : null}
          {quand ? <> le {quand}</> : null}.
          {" "}L'option « appliquer dès le mois en cours » n'ayant pas été cochée, les mois
          déjà générés ont gardé l'ancien prix.
        </div>

        <div style={{ marginBottom:8 }}>
          {aRevoir.length > 1 ? "Ces mois seront réécrits" : "Ce mois sera réécrit"} au nouveau tarif :
        </div>
        <div style={{ border:"1px solid #e5e7eb", borderRadius:8, overflow:"hidden", marginBottom:14 }}>
          {aRevoir.map((m, i) => (
            <div key={m.id || m.periode} style={{
              display:"flex", justifyContent:"space-between", alignItems:"center", gap:10,
              padding:"9px 12px", borderTop: i ? "1px solid #f3f4f6" : "none",
            }}>
              <span style={{ fontWeight:600 }}>{m.label || m.periode}</span>
              <span>
                <span style={{ color:"#9ca3af", textDecoration:"line-through" }}>{f(m.montant)} F</span>
                <span style={{ margin:"0 6px", color:"#9ca3af" }}>→</span>
                <span style={{ fontWeight:700, color:"#15803d" }}>{f(mensualite)} F</span>
              </span>
            </div>
          ))}
        </div>

        <div style={{ fontSize:11.5, color:"#6b7280", lineHeight:1.55, marginBottom:16 }}>
          Ne sont jamais touchés : les mois passés, ceux sur lesquels un versement a déjà été
          reçu, et ceux gelés par une suspension. Le passé garde son prix.
        </div>

        <div style={{ display:"flex", gap:10, justifyContent:"flex-end" }}>
          <button onClick={onClose} style={btnSecondary}>Annuler</button>
          <button onClick={appliquer} disabled={envoi}
            style={{ ...btnPrimary, opacity: envoi ? 0.7 : 1, cursor: envoi ? "not-allowed" : "pointer" }}>
            {envoi ? "⏳ Alignement…" : `✅ Aligner sur ${f(mensualite)} F`}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalAlignementTarif;
